import { useMemo, useState } from 'react'
import { createGeometricOutlineCanvas, outlineToOverlay } from '../utils/imageProcessing'
import { IconClose } from './Icons'
import './GeometricBuilder.css'

const SHAPES = [
  { id: 'circle', label: 'עיגול' },
  { id: 'square', label: 'ריבוע' },
  { id: 'rectangle', label: 'מלבן' },
  { id: 'triangle', label: 'משולש' },
  { id: 'pentagon', label: 'מחומש' },
  { id: 'hexagon', label: 'משושה' },
  { id: 'diamond', label: 'מעויין' },
]

export function GeometricBuilder({ onCreate, onClose }) {
  const [shapeId, setShapeId] = useState('circle')
  const [size, setSize] = useState(512)
  const [padding, setPadding] = useState(0.14)
  const [lineWidth, setLineWidth] = useState(6)

  const previewUrl = useMemo(() => {
    try {
      const outline = createGeometricOutlineCanvas(shapeId, { size: 320, padding, lineWidth: Math.max(3, Math.round(lineWidth * 0.75)) })
      const overlay = outlineToOverlay(outline)
      return overlay.toDataURL('image/png')
    } catch {
      return null
    }
  }, [shapeId, padding, lineWidth])

  return (
    <div className="geo-builder-modal" role="dialog" aria-modal="true" aria-label="בונה צורות גאומטריות">
      <div className="geo-builder-backdrop" onClick={onClose} aria-hidden />
      <div className="geo-builder-panel" onClick={(e) => e.stopPropagation()}>
        <div className="geo-builder-header">
          <h2>צורות גאומטריות</h2>
          <button type="button" className="geo-builder-close" onClick={onClose} aria-label="סגור">
            <IconClose size={22} />
          </button>
        </div>

        <div className="geo-builder-body">
          <div className="geo-builder-preview">
            {previewUrl ? <img src={previewUrl} alt="" /> : <div className="geo-builder-preview-fallback">תצוגה מקדימה</div>}
          </div>

          <div className="geo-builder-controls">
            <label className="geo-builder-row">
              <span className="geo-builder-label">צורה</span>
              <select className="geo-builder-select" value={shapeId} onChange={(e) => setShapeId(e.target.value)}>
                {SHAPES.map((s) => (
                  <option key={s.id} value={s.id}>{s.label}</option>
                ))}
              </select>
            </label>

            <label className="geo-builder-row">
              <span className="geo-builder-label">גודל דף</span>
              <select className="geo-builder-select" value={String(size)} onChange={(e) => setSize(Number(e.target.value))}>
                <option value="420">קטן</option>
                <option value="512">בינוני</option>
                <option value="640">גדול</option>
                <option value="800">ענק</option>
              </select>
            </label>

            <label className="geo-builder-row">
              <span className="geo-builder-label">גודל צורה</span>
              <input
                className="geo-builder-range"
                type="range"
                min="0.06"
                max="0.28"
                step="0.01"
                value={padding}
                onChange={(e) => setPadding(Number(e.target.value))}
              />
            </label>

            <label className="geo-builder-row">
              <span className="geo-builder-label">עובי קו</span>
              <input
                className="geo-builder-range"
                type="range"
                min="3"
                max="14"
                step="1"
                value={lineWidth}
                onChange={(e) => setLineWidth(Number(e.target.value))}
              />
            </label>

            <button
              type="button"
              className="geo-builder-create"
              onClick={() => {
                const outline = createGeometricOutlineCanvas(shapeId, { size, padding, lineWidth })
                onCreate(outline)
                onClose?.()
              }}
            >
              צור דף לצביעה
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

